
import React from "react";
import { Edit, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { DocumentProps } from "@/hooks/admin/identity-docs/useSubmittedDocuments";

interface DocumentViewButtonProps {
  document: DocumentProps;
  variant?: "outline" | "ghost";
  size?: "sm" | "icon";
  showText?: boolean;
}

export function DocumentViewButton({ 
  document, 
  variant = "outline", 
  size = "sm",
  showText = true 
}: DocumentViewButtonProps) {
  const navigate = useNavigate();

  const handleViewDocument = () => {
    navigate(`/admin/documents/${document.id}`);
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleViewDocument}
      className={showText ? "flex items-center gap-1" : ""}
    >
      {showText ? <Edit className="h-3 w-3" /> : <Eye className="h-4 w-4" />}
      {showText && "View"}
    </Button>
  );
}
